export default __webpack_public_path__ + "static/media/ap-punti.03dc58b8.svg";